<template>
  <div class="driver">
    <div class="card">
      <div class="driver__details">
        <div>
          <img src="../../../assets/user2.png">
        </div>
        <div class="driver__info">
          <div>Name: {{ driver.first_name }} {{ driver.last_name }}</div>
          <div>Tel-No: {{ driver.username }}</div>
          <div>Status: Active</div>
        </div>
      </div>
      <div class="driver__actions">
        <el-button size="small" @click="editDriver" type="warning">EDIT</el-button>
        <el-button size="small" type="danger">DE-ACTIVATE</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DriverDetail',
  props: ['driver'],
  methods: {
    editDriver () {
      // call the user path url for editing
      console.log('Editing driver')
    }
  }
}
</script>

<style src="./details.scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/driver/Details.vue